export const SET_TIMELINE_FIELD = 'SET_TIMELINE_FIELD';
import { API_END_POINT, get } from '../Core/http';
import {comparingDate, customFormatDate, customAddDate, convertFullTime} from '../Core/date';
import { setAppointmentField } from 'jsTheme/Actions/Appointments.action';
import {isAnyOne} from '../Core/utils';

export const getSchedulers = (isShowAll = true, validateStep = null) => (dispatch, getState) => {
	let {shop, timelines, appointments, history} = getState(),
		date = new Date(timelines.selectedCalendar),
		newDate = comparingDate(shop.fromDate, date) ? date : new Date(shop.fromDate),
		endDateWeek = customAddDate(newDate, 6),
		param = {},
		fromDate = customFormatDate(newDate),
		toDate = customFormatDate(endDateWeek);	
	if(appointments.selectedProducts !== ''){
		param = { 
			...param,
			selectedProductIds: appointments.selectedProducts 
		}
	}
	if(history.typeAppt === 'edit'){
		param = {
			...param,
			appointmentEditId: history.apptId
		}
	}
	if(!isAnyOne(appointments.selectedEmployees) && isShowAll) {
		param = { ...param, selectedEmployeeId: appointments.selectedEmployees}
	}
  	const params={
     	fromDate,
     	toDate,
		shopId: shop.id,				
		...param
	   },
	   query = Object.entries(params).map(([key, value])=> `${key}=${value}`).join('&');
	
	let elHeader = document.getElementsByClassName('content-timeline');
	if(elHeader.length > 0){
		elHeader[0].classList.add('loading');
	}
	//let startTimeApi = new Date().getTime();
	return get(`${API_END_POINT}/${shop.apiVersion}/shop/schedulers/info${query.length>0?'?':''}${query}`)
		.then(response => response.json())
		.then(result => {	
			const {minTime, maxTime, dateStates} = result;
			dispatch(_setTimeLineField([
				{key: 'minTime', value: minTime ? minTime : shop.minTimeWorking},
				{key: 'maxTime', value: maxTime ? maxTime : shop.maxTimeWorking},
				{key: 'listTimeLine', value: dateStates},
				{key: 'selectedCalendar', value: fromDate}
			]));
			if(history.typeAppt === 'edit' && appointments.selectedTimeline.from){
				let listTimeOfDate = dateStates.find(item => item.date === appointments.selectedCalendar);
				if(listTimeOfDate && listTimeOfDate.status === 'OK'){
					let fromTimeIndex = listTimeOfDate.timeStates.find(item => item.time === appointments.selectedTimeline.from),
						isValidRange = true;

					// while(tempIndex <= toTimeIndex){
					// 	if(listTimeOfDate.timeStates.length > 0 && listTimeOfDate.timeStates[tempIndex].status !== 'OK') isValidRange = false;						
					// 	tempIndex++;
					// }
					if(!fromTimeIndex || (fromTimeIndex && fromTimeIndex.status !== 'OK')) isValidRange = false;	
					//if(fromTimeIndex && fromTimeIndex.status !== 'OK')
					if(!isValidRange){
						dispatch(setAppointmentField([
							{key: 'selectedTimeline',value: {from: null,to: null}},
							{key: 'selectedCalendar', value: customFormatDate(new Date())}
						]));
						if(validateStep){
							validateStep();
						}
					}
				}
			}			
			//gaTiming(shopTheme, 'Api get schedulers', 'Successfully', startTimeApi);
			setTimeout(function(){
                if(elHeader.length > 0){
                    elHeader[0].classList.remove('loading')
                }                
            },100)
		})
		.catch(error => {						
			if(elHeader.length > 0){
				elHeader[0].classList.remove('loading')
			} 		
			dispatch(setAppointmentField([{key: 'statusSubmit', value: 'ERROR SERVER'}]));
			//gaTiming(shopTheme, 'Api get schedulers', 'Failed/'+error.message, startTimeApi);
		});
}

export const setTimeLineField = list => (dispatch, getState) => {
	dispatch(_setTimeLineField(list))
}


const _setTimeLineField = listField => ({
	type: SET_TIMELINE_FIELD,
	payload: {
		listField
	}
})
